export function parsePrograms(programs: { value: string; display_value: string }[]) {
  return programs?.map((program) => ({ ...program, value: program.display_value }));
}
